module.exports = __webpack_public_path__ + "img/8.55feef4d.jpg";